// Auto-generated normalizer for table: RespuestaExamenOpcionMultiple_Det
export function respuestaExamenOpcionMultipleDetNormalize(row) {
  return {
    idExamenOpcionMultipleDet: row.idExamenOpcionMultipleDet ?? row.idExamenOpcionMultipleDet ?? row.IdExamenOpcionMultiple_Det ?? row['idExamenOpcionMultiple_Det'] ?? 0,
    idExamenRespuesta: row.idExamenRespuesta ?? row.IdExamenRespuesta ?? row['IdExamenRespuesta'] ?? 0,
    idOpcion: row.idOpcion ?? row.IdOpcion ?? row['IdOpcion'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
